export default "__VITE_ASSET__CPYoD0e0__"